// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"85456c1f","833":"f9ddf9ac"}[chunkId] + ".chunk.js";
};